module.exports = __webpack_public_path__ + "static/zlotnik-hex-99ced3787a4c637bc1f7070c58d29878.png";